import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 19v-6a8 8 0 0 1 8 -8h6","key":"svg-0"}]]

const IconRadiusTopLeft = createReactComponent('outline', 'radius-top-left', 'RadiusTopLeft', __iconNode);

export default IconRadiusTopLeft;